import type { Enums } from '@xleddyl/types'
import { useDashboardRbac } from '~/composables/api/queries/dashboard-rbac'

type Props = (scopes: Enums<'ORGANIZATION_RBAC_SCOPE'>[]) => boolean

declare module 'vue' {
   interface ComponentCustomProperties {
      $rbac: Props
   }
}

export default defineNuxtPlugin(() => {
   const route = useRoute()

   const organizationId = computed(() => route.params.id as string)
   const dashboardRbac = useDashboardRbac(
      computed(() => ({
         p_organization_id: organizationId.value,
         enabled: !!organizationId.value,
      }))
   )

   return {
      provide: {
         rbac: (scopes: Enums<'ORGANIZATION_RBAC_SCOPE'>[]) => {
            return scopes.every((s) => dashboardRbac.data.value?.includes(s))
         },
      },
   }
})
